import api from '../../../services/apiClient';

export async function getRequestsList({search, date_from, page, pageSize, sortBy, sortDirection, filters}){

    const fieldsCons = { 
            id: "_id", 
            name: "child.firstName", 
            certificate: "child.birthCertificate.number", 
            submitted: "createdAt", 
            sendFrom: "preferDateFrom", 
            status: "currentStatus.name",
            note: "my_request"
    };

    const transformField = {
        sendFrom: { 
            type: "date",
            changeOpt: "submitted"
        
        },
        submitted: { type: "date" },
        status: { 
            transl: {
            "invite-accepted": "Надання документів",
            "approved": "Садочок обраний",
            "invite-sent": "Надіслано запрошення",
            "need-check": "Прийнята",
            "child-in-kindergarten": "Дитина оформлена",
            "banned": "Заблокована"
            },
            add: {
                field: "statusClass",
                values: {
                    "invite-accepted": "status-docs",
                    "approved": "status-selected",
                    "invite-sent": "status-chosen",
                    "need-check": "status-selected",
                    "child-in-kindergarten": "status-selected",
                    "banned": "status-banned"
                }
            }
        },
        note: {
            transl:{
                "viewer": "",
                "owner": "Це ваша заявка"
            }
        }
    };

    const getValue = (object, path) => path.split('.').reduce((o, k) => (o || {})[k], object);
      
    const transfFunc = (data)=>{

        const fArr = Object.keys(fieldsCons);

        const fieldTo = data.map(r=>{
            const outr = {};

            fArr.forEach(k=>{

                const val = getValue(r, fieldsCons[k]);
                
                if(transformField[k] && transformField[k].transl && transformField[k].transl[val]) outr[k] = transformField[k].transl[val];
                if(transformField[k] && transformField[k].add && transformField[k].add.values && transformField[k].add.values[val]) outr[transformField[k].add.field] = transformField[k].add.values[val];
                if(transformField[k] && transformField[k].type && transformField[k].type == "date" && val) {
                    const d_p = val.split("T")[0].split("-");
                    outr[k] = `${d_p[2]}.${d_p[1]}.${d_p[0]}`;
                }

                if(transformField[k] && transformField[k].changeOpt && transformField[k].type == "date" && !val) {

                    const d_p = r[fieldsCons[transformField[k].changeOpt]].split("T")[0].split("-");
                    outr[k] = `${d_p[2]}.${d_p[1]}.${d_p[0]}`;
                }

                if(!transformField[k]) outr[k] = val;


            });

            return outr;
        });

        return fieldTo;
    }

    const data = {
        page,
        limit: pageSize,
        search: {
            date_from: date_from || '2000-01-01',
            search
        },
        fields: Object.keys(fieldsCons).map(f=>fieldsCons[f]),
        sortfield: fieldsCons[sortBy],
        sortdirect: sortDirection

    };

    if(filters.filter_selected_zdo) data.search['last_status'] = 'approved';
    if(filters.filter_benefits) data.search['with_benefits'] = 'all';
    if(filters.filter_owner) data.search["owner"] = 'owner';

    const info = await api.post('get_requests_pag', data);

    if(!info.data) return ({ all_count: 0, data: []});

    return ({all_count: info.data.all_count, data: transfFunc(info.data.data)});
    
}